import { render, staticRenderFns } from "./permissionsEditBox.vue?vue&type=template&id=c94775d0&"
import script from "./permissionsEditBox.vue?vue&type=script&lang=ts&"
export * from "./permissionsEditBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports